import React, { useEffect, useState, useRef } from "react";
import { inject, observer } from "mobx-react"; // eslint-disable-line
import { AnalyticsEvent } from "../../components/elements/analytics-event";
import CountUp from "react-countup";
import axios from "axios";

const DashboardShow = (props) => {
  const [donorFilter, setDonorFilter] = useState([]);
  const [state, setState] = useState({
    nextup: "Loading run of show...",
    name: "name",
    amount: "amount",
    message: "message",
  });

  const timer = useRef(0);

  useEffect(() => {
    /* Remove for production */
    const url = `${process.env.REACT_APP_LOCAL_URI}/dashboard-show/`;
    /* Remove for production */

    let streamer = window.location.href.replace(url, "").split("/");
    if (streamer[0][0] === "@" || streamer[0][0] === "+") {
      streamer[2] = streamer[0][0];
      streamer[0] = streamer[0].substr(1, streamer[0].length);
    } else {
      streamer[2] = "@";
    }

    if (streamer[0] !== "") {
      let streamType = streamer[2],
        username = streamer[0],
        slug = streamer[1];

      /* Remove for production */
      props.overlayStore.socketConnect(streamType, username, slug);

      timer.current = setInterval(() => receive(), 10000);

      return () => {
        props.overlayStore.socketDisconnect();
        clearInterval(timer.current);
      };
    }
  }, []);

  const {
    donations,
    polls,
    goal,
    goalVal,
    progress,
    exactPercent,
    percent,
    raised,
    raisedVal,
    milestones,
    milestoneSort,
    rewards,
    remainingVal,
    campaignID,
  } = props.overlayStore;

  document.body.classList.add("dark");

  const formatNumber = (num) => {
    let value = num;
    const res = String(num).split(".");
    if (res.length === 1 || res[1].length <= 3) {
      value = value
        .toFixed(2)
        .replace(/\.00$/, "")
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
    return value;
  };

  const receive = () => {
    console.log("receive ran");
    const URL = process.env.REACT_APP_SERVICE_URI + "/getNextUp/";
    // console.log("AS Going to write PG:", useMinDono);
    axios
      .post(URL)
      .then((response) => {
        setState((prev) => {
          return {
            ...prev,
            nextup: response.data.nextup,
          };
        });
        console.log("NextUp back from PG write", response);
      })
      .catch((err) => console.log("***** write to PG error:", err));
  };

  useEffect(() => {
    const donorList = donations.map((donation) => {
      return {
        id: donation.id,
        name: donation.donor_name,
        amount: Number(donation.amount.value),
        comment: donation.donor_comment,
        rewardID: donation.reward_id === undefined ? 0 : donation.reward_id,
        pollID:
          donation.poll_option_id === undefined ? 0 : donation.poll_option_id,
      };
    });

    const rewardList = rewards.map((reward) => {
      return {
        rewardId: reward.id,
        rewardName: reward.name,
      };
    });

    const pollList = polls.map((poll) => {
      return {
        pollsID: poll.id,
        pollsName: poll.name,
        pollsOption: poll.options.map((option) => {
          return {
            optionId: option.id,
            optionName: option.name,
          };
        }),
      };
    });

    const pollOptionsList = pollList.reduce((optionsArray, poll) => {
      optionsArray.push(poll.pollsOption);
      return optionsArray;
    }, []);

    const optionsList = pollOptionsList.flatMap((x) => x);

    let causeList = [
      {
        causeId: "5bc5db5c-40a8-4306-a6a9-1592cbc8ab50",
        causeName: "Red Wagon for St. Jude",
      },
      {
        causeId: "a2997e00-1e0c-4eb9-b435-1ff5b2ab759b",
        causeName: "Art Supplies for St. Jude",
      },
      {
        causeId: "e98114f6-fe8c-41db-bf7f-c977e6d07803",
        causeName: "Family Meal Card for St. Jude",
      },
      {
        causeId: "0845427c-5979-4bd4-a223-2673d36ae25a",
        causeName: "No More Chemo Party",
      },
      {
        causeId: "b94bc9f8-7bf9-46a1-a683-a905b6ad0fcc",
        causeName: "2/3 Share of Chemotherapy Treatment",
      },
      {
        causeId: "b9d0d014-42f4-49b4-a230-8c4eb27db13e",
        causeName: "New Toy for Hospital Play Areas",
      },
      {
        causeId: "b12bef25-e5f3-4a27-b8b1-8271df77ffaf",
        causeName: "Share of Bone Marrow Treatment",
      },
    ];

    const donorResult = donorList.map((result) => {
      const rewardItem = rewardList.find(
        (rewardName) => rewardName.rewardId === result.rewardID
      );

      const causeItem = causeList.find(
        (causeName) => causeName.causeId === result.rewardID
      );

      const optionItem = optionsList.find(
        (optionName) => optionName.optionId === result.pollID
      );

      result.rewardName = rewardItem ? rewardItem.rewardName : null;
      result.causeName = causeItem ? causeItem.causeName : null;
      result.optionName = optionItem ? optionItem.optionName : null;

      return result;
    });

    console.log(donorList);

    setDonorFilter(
      donorResult.filter((donation) => Number(donation.amount) >= minDonation)
    );
  }, [donations, polls]);

  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);
  const minDonation = urlParams.get("minDonation");
  const highlight = urlParams.get("highlight");
  const donorMin = urlParams.get("donorMin");

  return (
    <div className="dashboard">
      {AnalyticsEvent("english", "/", "PLAY LIVE Dashboard")}
      <section className="inner-row gutters constrain content">
        <div className="col-6">
          <div className="inner-row gutters constrain content">
            <div className="col-12 raised show">
              <p className="header">Total Amount Raised</p>
              <h1>
                $
                <CountUp
                  end={raised}
                  duration={1}
                  separator=","
                  decimals={
                    props.raised - Math.floor(props.raised) !== 0 ? 2 : 0
                  }
                  preserveValue={true}
                  useEasing={false}
                />
              </h1>
              <p className="header remaining">
                ${goal - raised <= 0 ? 0 : remainingVal} Remaining
              </p>
            </div>
          </div>
          <div className="next-up">
            <p className="header">Up Next</p>
            <p className="next">{state.nextup}</p>
          </div>
          {milestones.length > 0 ? (
            <div className="milestones">
              <p className="header">Next Milestone</p>
              {milestoneSort.map((milestone) => (
                <div
                  key={milestone.id}
                  // id={`${Number(100 * Number(milestone.amount) / Number(goal))}` + ' ' + exactPercent}
                  className={`
                        ${
                          Number(
                            100 *
                              (Number(milestone.amount.value) / Number(goal))
                          ) > progress
                            ? "milestones__text higher"
                            : "milestones__text lower"
                        }
                      `}
                >
                  <p className="m_info2">
                    <span className="mamount">
                      $
                      {formatNumber(
                        Math.round(
                          parseFloat(milestone.amount.value) -
                            parseFloat(raised)
                        )
                      )}
                    </span>

                    <span className="mtotal">
                      away from ${formatNumber(Number(milestone.amount.value))}
                    </span>
                  </p>
                  <p className="m_info1">{milestone.name}</p>
                </div>
              ))}
              <div className="milestones__text higher">
                <p>All milestones have been successfully completed</p>
              </div>
            </div>
          ) : (
            <div className="milestones">
              <p className="header">Next Milestone</p>
              <div className="milestones__none">
                <p>There are no active milestones for this campaign</p>
              </div>
            </div>
          )}
        </div>
        <div className="col-6">
          <div className={campaignID === 166464 ? "donors event" : "donors"}>
            <p className="header">
              {minDonation > 0
                ? "Recent Donations over $" + minDonation
                : "Recent Donations"}
            </p>
            <ul>
              {donorFilter.slice(0, donorMin).map((donor) => (
                <li
                  key={donor.id}
                  className={
                    donor.amount >= highlight ? "show tier5" : " show normal"
                  }
                >
                  <strong>{donor.name}</strong>{" "}
                  <span className="donation-amount">
                    ${formatNumber(donor.amount)}
                  </span>{" "}
                  {donor.comment ? (
                    <p className="donors_comment">
                      <strong>Comment: </strong>
                      {donor.comment}
                    </p>
                  ) : (
                    ""
                  )}
                  {donor.rewardName ? (
                    <div>
                      {donor.rewardID ===
                        "5bc5db5c-40a8-4306-a6a9-1592cbc8ab50" ||
                      donor.rewardID ===
                        "5bc5db5c-40a8-4306-a6a9-1592cbc8ab50" ||
                      donor.rewardID ===
                        "e98114f6-fe8c-41db-bf7f-c977e6d07803" ||
                      donor.rewardID ===
                        "0845427c-5979-4bd4-a223-2673d36ae25a" ||
                      donor.rewardID ===
                        "b94bc9f8-7bf9-46a1-a683-a905b6ad0fcc" ||
                      donor.rewardID ===
                        "b9d0d014-42f4-49b4-a230-8c4eb27db13e" ||
                      donor.rewardID ===
                        "b12bef25-e5f3-4a27-b8b1-8271df77ffaf" ? (
                        ""
                      ) : (
                        <div>
                          <p className="donors_reward">
                            <em>
                              <strong>Reward: </strong>
                              {donor.rewardName}
                            </em>
                          </p>
                        </div>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                  {donor.causeName ? (
                    <p className="donors_reward">
                      <em>
                        <strong>Reward: </strong>
                        {donor.causeName}
                      </em>
                    </p>
                  ) : (
                    ""
                  )}
                  {donor.optionName ? (
                    <p className="donors_poll">
                      <em>
                        <strong>Poll: </strong>
                        {donor.optionName}
                      </em>
                    </p>
                  ) : (
                    ""
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default inject("overlayStore", "eventStore")(observer(DashboardShow));
